<template>
  <v-app class='app'>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  mounted() {
    document.oncontextmenu = () => false;
  },

  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>
.v-application--wrap {
  min-height: auto!important;
}
</style>

<style lang="scss">
html, body {
  //フォントをヒラギノ角ゴに変更
  font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
  overflow-x: hidden;

  background-image: url('/img/pc_back.jpg');
  background-attachment: fixed;
  background-position: center;
  background-size: auto 120%;

  @media screen and  (max-width: $tabletWidth) {
    background-image: none;
    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-image: url('/img/sp_back.png');
      background-size: 100% auto;
      z-index: -1;
    }
  }
}
.v-application {
  // font-family: $notoSans!important;
  font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif !important;
  background: none!important;
}
#app {
  font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif !important;
  background: none!important;
}
</style>
